const _excluded = ["className", "complete", "invalid"],
  _excluded2 = ["valueState"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef } from 'react';
import cn from 'classnames';
import { Button, Callout, Typography } from 'seagull';
import { useIoContext } from "../../contexts";
import { Intent } from "../../infra/access-control";
import styles from "./ConnectCreditCard.module.scss";
import mpmStyles from "./ManagePaymentMethods.module.scss";
import { useConnectCreditCard } from "./useConnectCreditCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Label = props => {
  const {
    children,
    size = 'small'
  } = props;
  return /*#__PURE__*/_jsx(Typography, {
    className: cn(mpmStyles.label, {
      [mpmStyles.mediumSize]: size === 'medium'
    }),
    variant: size === 'small' ? 'paragraph2' : 'paragraph1',
    children: children
  });
};
const Field = props => /*#__PURE__*/_jsx("div", {
  className: cn(mpmStyles.field, {
    [mpmStyles.marginTop]: !props.isFirst,
    [mpmStyles.largeMargin]: props.largeMargin
  }, props.className),
  children: props.children
});
const ErrorText = props => /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, props), {}, {
  className: cn(mpmStyles.error, props.className),
  variant: "paragraph2"
}));
const BaseInput = /*#__PURE__*/forwardRef(function Input(props, ref) {
  const {
      className,
      complete,
      invalid
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(mpmStyles.input, {
      [mpmStyles.complete]: complete,
      [mpmStyles.invalid]: invalid
    }, className),
    ref: ref
  }));
});
const Input = props => {
  const {
      valueState
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_jsx(BaseInput, _objectSpread(_objectSpread({}, rest), {}, {
    complete: valueState.touched && !valueState.error,
    invalid: valueState.touched && !!valueState.error,
    value: valueState.value
  }));
};

/**
 * Legacy credit card form UI.
 * Expects to be wrapped in an Elements provider from @stripe/react-stripe-js.
 */
export default function ConnectCreditCardLegacy(props) {
  const {
    reactStripe: {
      CardNumberElement,
      CardExpiryElement,
      CardCvcElement
    }
  } = useIoContext();
  const {
    cardNum,
    cardNumDispatch,
    expiry,
    expiryDispatch,
    cvv,
    cvvDispatch,
    nameOnCard,
    setNameOnCard,
    zipCode,
    setZipCode,
    apiError,
    setApiError,
    submitting,
    allFieldsValid,
    disabledReason,
    doPaymentMethodAction,
    stripeLoadingFailed,
    styleObj,
    classesObj,
    validateNameOnCard,
    validateZipCode,
    connectCreditCard
  } = useConnectCreditCard(props);
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: e => {
      e.preventDefault();
      doPaymentMethodAction(connectCreditCard);
    },
    children: [/*#__PURE__*/_jsxs(Field, {
      isFirst: true,
      children: [/*#__PURE__*/_jsx(Label, {
        children: "Name on card"
      }), /*#__PURE__*/_jsx(Input, {
        valueState: nameOnCard,
        placeholder: "Enter your name",
        "data-testid": "manage-payment-methods-credit-card-name",
        className: cn(mpmStyles.input, {
          [mpmStyles.invalid]: nameOnCard.touched && nameOnCard.error
        }),
        disabled: !!disabledReason,
        onChange: ev => {
          setApiError(undefined);
          const error = validateNameOnCard(ev.currentTarget.value);
          setNameOnCard(_objectSpread(_objectSpread({}, nameOnCard), {}, {
            value: ev.currentTarget.value,
            pristine: false,
            error
          }));
        },
        onBlur: () => {
          const error = validateNameOnCard(nameOnCard.value);
          setNameOnCard(_objectSpread(_objectSpread({}, nameOnCard), {}, {
            error,
            touched: true
          }));
        }
      }), nameOnCard.error && nameOnCard.touched && /*#__PURE__*/_jsx(ErrorText, {
        "data-testid": "connect-cc-name-error",
        children: nameOnCard.error
      })]
    }), /*#__PURE__*/_jsxs(Field, {
      children: [/*#__PURE__*/_jsx(Label, {
        children: "Card number"
      }), /*#__PURE__*/_jsx(CardNumberElement, {
        className: cn(mpmStyles.input, {
          [mpmStyles.invalid]: cardNum.touched && !cardNum.valid && cardNum.errorMessage
        }),
        options: {
          disabled: !!disabledReason,
          style: styleObj,
          classes: classesObj,
          placeholder: '0000-0000-0000-0000'
        },
        onChange: event => {
          const {
            complete,
            error,
            empty
          } = event;
          setApiError(undefined);
          if (complete) {
            cardNumDispatch({
              type: 'valid'
            });
          } else {
            cardNumDispatch({
              type: 'error',
              errorMessage: error ? error.message : empty ? 'Please enter a valid card number' : ''
            });
          }
        },
        onBlur: () => cardNumDispatch({
          type: 'blur'
        })
      }), cardNum.touched && !cardNum.valid && /*#__PURE__*/_jsx(ErrorText, {
        "data-testid": "connect-cc-num-error",
        children: cardNum.errorMessage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.ccExpirationRow,
      children: [/*#__PURE__*/_jsxs(Field, {
        className: styles.ccExpirationField,
        children: [/*#__PURE__*/_jsx(Label, {
          children: "Expiration date"
        }), /*#__PURE__*/_jsx(CardExpiryElement, {
          "data-testid": "manage-payment-methods-credit-card-expiry",
          className: cn(mpmStyles.input, {
            [mpmStyles.invalid]: expiry.touched && expiry.errorMessage
          }),
          options: {
            disabled: !!disabledReason,
            style: styleObj,
            classes: classesObj,
            placeholder: 'MM/YY'
          },
          onChange: event => {
            const {
              complete,
              error,
              empty
            } = event;
            setApiError(undefined);
            if (complete) {
              expiryDispatch({
                type: 'valid'
              });
            } else {
              expiryDispatch({
                type: 'error',
                errorMessage: error ? error.message : empty ? 'Please enter a valid card expiry date' : ''
              });
            }
          },
          onBlur: () => expiryDispatch({
            type: 'blur'
          })
        }), expiry.touched && !expiry.valid && /*#__PURE__*/_jsx(ErrorText, {
          "data-testid": "connect-cc-expiry-error",
          children: expiry.errorMessage
        })]
      }), /*#__PURE__*/_jsxs(Field, {
        className: styles.ccExpirationField,
        children: [/*#__PURE__*/_jsx(Label, {
          children: "CVV"
        }), /*#__PURE__*/_jsx(CardCvcElement, {
          className: cn(mpmStyles.input, {
            [mpmStyles.invalid]: cvv.touched && cvv.errorMessage
          }),
          options: {
            disabled: !!disabledReason,
            style: styleObj,
            classes: classesObj,
            placeholder: 'CVV'
          },
          onChange: event => {
            const {
              complete,
              error,
              empty
            } = event;
            setApiError(undefined);
            if (complete) {
              cvvDispatch({
                type: 'valid'
              });
            } else {
              cvvDispatch({
                type: 'error',
                errorMessage: error ? error.message : empty ? 'Please enter a valid CVV' : ''
              });
            }
          },
          onBlur: () => cvvDispatch({
            type: 'blur'
          })
        }), cvv.touched && !cvv.valid && /*#__PURE__*/_jsx(ErrorText, {
          "data-testid": "connect-cc-cvv-error",
          children: cvv.errorMessage
        })]
      }), /*#__PURE__*/_jsxs(Field, {
        className: styles.ccExpirationField,
        children: [/*#__PURE__*/_jsx(Label, {
          children: "Zip code"
        }), /*#__PURE__*/_jsx(Input, {
          valueState: zipCode,
          type: "text",
          placeholder: "Zip code",
          "data-testid": "connect-cc-zip",
          disabled: !!disabledReason,
          className: cn(mpmStyles.input, {
            [mpmStyles.invalid]: zipCode.touched && zipCode.error
          }),
          onChange: ev => {
            setApiError(undefined);
            const value = ev.target.value.trim();
            const error = validateZipCode(value, -1);
            setZipCode(_objectSpread(_objectSpread({}, zipCode), {}, {
              value,
              pristine: false,
              error
            }));
          },
          onBlur: () => {
            const error = validateZipCode(zipCode.value, -1);
            setZipCode(_objectSpread(_objectSpread({}, zipCode), {}, {
              touched: true,
              error
            }));
          }
        }), zipCode.error && zipCode.touched && /*#__PURE__*/_jsx(ErrorText, {
          "data-testid": "connect-cc-zip-error",
          children: zipCode.error
        })]
      })]
    }), /*#__PURE__*/_jsxs(Field, {
      largeMargin: true,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "submit",
        size: "small",
        disabled: !!(!allFieldsValid || apiError || stripeLoadingFailed),
        loading: submitting,
        testId: "manage-payment-methods-add-credit-card",
        intent: Intent.AddPaymentMethod,
        tooltip: {
          placement: 'top',
          title: disabledReason ? /*#__PURE__*/_jsx("div", {
            "data-testid": "add-cc-disabled-reason",
            children: disabledReason
          }) : '',
          testId: 'connect-cc-submit-btn-tooltip',
          disableFocusListener: disabledReason == null,
          disableHoverListener: disabledReason == null,
          disableTouchListener: disabledReason == null
        },
        children: "Connect credit card"
      }), (apiError || stripeLoadingFailed) && /*#__PURE__*/_jsx(Callout, {
        className: styles.error,
        intent: "error",
        testId: "manage-payment-methods-cc-error",
        children: stripeLoadingFailed ? 'An error has occurred. Refresh the page and try again' : apiError
      })]
    })]
  });
}